import { supabase } from './supabase'

const PLAIN_JOB_NUMBER = /^JOB-(\d+)$/

/**
 * Next sequential job number, mirroring the DB-side generators:
 * max numeric value over plain JOB-#### numbers + 1. Ignores recurring
 * sibling numbers like JOB-0042-17, which used to cause duplicate-key
 * collisions when parsed naively from the most recent row.
 */
export async function generateNextJobNumber(): Promise<string> {
  try {
    const { data, error } = await supabase
      .from('jobs')
      .select('job_number')
      .like('job_number', 'JOB-%')
      .order('created_at', { ascending: false })
      .limit(500)
    if (error) throw error

    let max = 0
    for (const row of data || []) {
      const match = PLAIN_JOB_NUMBER.exec(row.job_number || '')
      if (match) max = Math.max(max, parseInt(match[1], 10))
    }
    return `JOB-${String(max + 1).padStart(4, '0')}`
  } catch {
    return `JOB-${Date.now()}`
  }
}

/** Guaranteed-unique fallback when a generated number still collides. */
export function fallbackJobNumber(): string {
  return `JOB-${Date.now()}`
}

export function isDuplicateJobNumberError(error: any): boolean {
  return error?.code === '23505' && String(error?.message || '').includes('jobs_job_number_key')
}
